import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

//prime React
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
//components
import Select from "../../../../components/input/Select";
import NumberInput from "../../../../components/input/NumberInput";
//services

import CopyTextInput from "../../../../components/input/CopyTextInput";

import { postSendDays } from "../../../../services/Enterprise/WhatsppConfig/postSendDays";
import Input from "../../../../components/input/Input";
import { Editor } from "primereact/editor";
import { getEmailSendGrid } from "../../../../services/Enterprise/Email/getEmailSendGrid";
import { useQuery } from "react-query";
import { useAppContext } from "../../../../context/AppContext";

export default function EmailSendDays({ id, refetch }) {
  // eslint-disable-next-line no-unused-vars
  const { permissions } = useAppContext();
  const [loading, setLoading] = useState(false);
  const [text, setText] = useState(
    '<p>Olá <strong>@nome_cli</strong>, tudo bem?</p><p><br></p><p>Sua parcela do <strong>@nome_empreendimento</strong>, Quadra <strong>@quadra</strong> - Lote<strong> @lote</strong>, vencerá em <strong>@data_vencimento</strong>.</p><p><br></p><p>Clique no botão abaixo para imprimir o boleto.</p><p><br></p><p><br></p><p class="ql-align-center">@link_boleto</p><p><br></p><p><br></p><p>O pagamento até a data de vencimento evitará multa e juros.</p><p><br></p><p>Caso o boleto já tenha sido pago, favor desconsiderar este e-mail.</p><p><br></p><p>Atenciosamente,</p><p><strong>@nome_empreendimento</strong></p><p><br></p><p><strong>E-mail: email@email.com</strong></p><p><br></p><p><strong>Telefone/Whatsapp: (XX) XXXXX-XXXX</strong></p>'
  );
  //  // console.log(objData);
  const variables = [
    { id: 1, name: "@nome_cli" },
    { id: 2, name: "@nome_empreendimento" },
    { id: 3, name: "@valor_parcelas" },
    { id: 4, name: "@data_vencimento" },
    { id: 5, name: "@quadra" },
    { id: 6, name: "@lote" },
    { id: 7, name: "@link_boleto" },
  ];

  const condition = [
    { value: "before", label: "Antes do Vencimento" },
    { value: "after", label: "Após o vencimento" },
  ];

  const form = useForm();
  const errors = form.formState.errors;

  useEffect(() => {
    form.setValue(
      "text",
      `Olá @nome_cli, tudo bem?\n\nSua parcela do @nome_empreendimento, quadra @quadra - Lote @lote, vencerá em @data_vencimento.\nClique no botão abaixo para imprimir o boleto.\n\n@link_boleto\n\nO pagamento até a data de vencimento evitará multa e juros.\n\nCaso o boleto já tenha sido pago, favor desconsiderar este e-mail.\n\n\nAtenciosamente,\n\n@nome_empreendimento\n\n\nE-mail: email@email.com\nTelefone/Whatsapp: (XX) XXXXX-XXXX`
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getFormErrorMessage = (name) => {
    return errors[name] ? (
      <small className="p-error">{errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };

  function onSubmit(data) {
    // console.log(data);
    setLoading(true);
    // console.log(text);
    let obj = {
      type: 1, //Email
      enterprise_id: id,
    };
    data.text = text;
    let newData = {
      ...obj,
      ...data,
    };

    const notification = toast.loading(
      "Por favor, aguarde a ação está sendo realizada..."
    );
    postSendDays(newData)
      .then(() => {
        toast.update(notification, {
          render: "Dias de envio adicionados com sucesso!",
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          type: "success",
          isLoading: false,
        });
      })
      .catch((error) => {
        toast.update(notification, {
          render: "Não foi possível adicionar os dias de envio!",
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          type: "error",
          isLoading: false,
        });
        console.error("Erro ao adicionar dias de envio:", error);
      })
      .finally(() => {
        refetch();
        form.reset();
        setLoading(false);
      });
  }

  //get
  // const {
  //   data: emails,
  //   refetch: refetchEmail,
  //   isLoading: isLoadingEmail,
  // } = useQuery({
  //   queryKey: ["emails"],
  //   queryFn: () => getEmailSendGrid(),
  //   enabled: !!permissions?.includes("91")
  // });

  // const formattedEmails = emails?.map((email) => ({
  //   value: email.id,
  //   label: `Nome: ${email.from_name} | E-mail:${email.from_email} - Nome Resposta: ${email.reply_to_name} | E-mail: ${email.reply_to}`,
  // }));

  return (
    <>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-md-12">
            <h4>Informe as configurações de disparo de e-mails</h4>
            <div className="row"></div>
          </div>
          <div className="col-md-12">
            <div className="row">
              {/* <div className="col-md-12 mt-4">
                <h4>
                  {" "}
                  E-mail para Envio / Resposta
                  <Tooltip target=".custom-target-icon" />
                  <i
                    className="custom-target-icon px-2 pi 
                      pi-info-circle p-text-secondary"
                    data-pr-tooltip="Configure qual será o e-mail para disparo de lembrete / cobrança"
                    style={{ cursor: "pointer" }}
                  ></i>{" "}
                </h4>{" "}
                <Select
                  suffix=""
                  options={formattedEmails || []}
                  isRequired={true}
                  name="sendgrid_id"
                  control={form.control}
                  label={isLoadingEmail ? "Carregando..." : "E-mail"}
                  getFormErrorMessage={getFormErrorMessage}
                  isDisabled={isLoadingEmail}
                />
              </div> */}
              <div className="col-md-4 form-group">
                <Input
                  suffix=""
                  isRequired={true}
                  name="reply_to_name"
                  control={form.control}
                  label="Nome para Resposta"
                  getFormErrorMessage={getFormErrorMessage}
                />
              </div>
              <div className="col-md-4 form-group">
                <Input
                  type="email"
                  suffix=""
                  isRequired={true}
                  name="reply_to"
                  control={form.control}
                  label="E-mail para Resposta"
                  getFormErrorMessage={getFormErrorMessage}
                />
              </div> 
              <div className="col-md-4 form-group">
                {/* <h4>
                  {" "}
                  Assunto do Email
                  <Tooltip target=".custom-target-icon" />
                  <i
                    className="custom-target-icon mx-2 pi 
                      pi-info-circle p-text-secondary"
                    data-pr-tooltip="Defina o Assunto do E-mail para envio de lembrete / cobrança"
                    style={{ cursor: "pointer" }}
                  ></i>
                </h4> */}
                <Input
                  suffix=""
                  isRequired={true}
                  name="subject"
                  control={form.control}
                  label="Assunto Envio"
                  getFormErrorMessage={getFormErrorMessage}
                />
              </div>
              <hr className="my-4" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-8">
            <div className="row">
              <div className="col-md-6 mt-4">
                <h4>
                  {" "}
                  Quantidade de Dias
                  <Tooltip target=".custom-target-icon" />
                  <i
                    className="custom-target-icon px-2 pi 
                    pi-info-circle p-text-secondary"
                    data-pr-tooltip="Configure a quantidade de dias que será enviada antes ou após o vencimento do boleto"
                    style={{ cursor: "pointer" }}
                  ></i>{" "}
                </h4>
                <NumberInput
                  suffix=""
                  placeholder="0"
                  max={90}
                  required={true}
                  minFractionDigits={0}
                  name="days"
                  control={form.control}
                  label="Dias"
                  getFormErrorMessage={getFormErrorMessage}
                />
              </div>
              <div className="col-md-6 mt-4">
                <h4>
                  {" "}
                  Condição
                  <Tooltip target=".custom-target-icon" />
                  <i
                    className="custom-target-icon mx-2 pi 
                    pi-info-circle p-text-secondary"
                    data-pr-tooltip="Configure se a mensagem será de cobrança ou lembrete"
                    style={{ cursor: "pointer" }}
                  ></i>
                </h4>
                <Select
                  isRequired={true}
                  name="before_or_after"
                  errors={errors}
                  label="Escolha"
                  options={condition}
                  control={form.control}
                />
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <h4>
              Variáveis <Tooltip target=".custom-target-icon" />
              <i
                className="custom-target-icon px-2 pi 
              pi-info-circle p-text-secondary"
                data-pr-tooltip="Utilize para automatizar dados da mensagem"
                style={{ cursor: "pointer" }}
              ></i>{" "}
            </h4>
            <div className="d-flex flex-wrap">
              {variables.map((v) => (
                <div className="p-2 my-1" key={v.id}>
                  <CopyTextInput
                    text={v.name}
                    onClick={() => {
                      toast.success(`Texto copiado com sucesso`);
                    }}
                  />
                </div>
              ))}
            </div>
          </div>

          <div className="row">
            <div className="col-md-8 mt-4">
              <h4>
                {" "}
                Modelo de Envio
                <Tooltip target=".custom-target-icon" />
                <i
                  className="custom-target-icon px-2 pi 
        pi-info-circle p-text-secondary"
                  data-pr-tooltip="Configure sua mensagem para disparo de avisos de cobrança"
                  style={{ cursor: "pointer" }}
                ></i>{" "}
              </h4>
              <Editor
                name="text"
                value={text}
                onTextChange={(e) => setText(e.htmlValue)}
                style={{ height: "320px" }}
              />
            </div>
            <div className="col-md-4 mt-4 align-self-end text-end">
              {" "}
              <Button
                rounded
                type="submit"
                loading={loading}
                iconPos="right"
                label="Cadastrar"
                icon="fa-solid fa-circle-chevron-right"
                className="p-inputtext-sm m-auto"
              />
            </div>
          </div>

          <hr className="my-4" />
        </div>
      </form>
    </>
  );
}
